import {post, jsonPost} from '@/http/api';

//库存查询
export const getStock = (params) => post('goodsInterfaces/v1.0/getHycStock', params)


// WEBPACK FOOTER //
// ./src/api/shop.js